import { useTranslation } from './useTranslation';

type TranslationField = Record<string, string | null> | string | null;

export const useMultilingualFields = () => {
    const { localeRef } = useTranslation();

    const getTranslatedValue = (translations: TranslationField, currentLocale?: string): string => {
        if (!translations) {
            return '-';
        }

        if (typeof translations === 'string') {
            return translations;
        }

        const locale = currentLocale || localeRef.value || 'en';

        const value = translations[locale] || translations.en;
        if (value) {
            return value;
        }

        for (const val of Object.values(translations)) {
            if (val) {
                return val;
            }
        }

        return '-';
    };

    return { getTranslatedValue };
};
